module.exports = __webpack_public_path__ + "static/media/bg-superiority-3.8cabe447.png";